import React, {useState, useEffect, useRef} from 'react'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'
import Dropdown from 'react-bootstrap/Dropdown'
import plusIcon from '../../../../_metronic/images/smlplus.svg'
import {GET_ALL_SCRIPTS_LIST, UPDATE_SCRIPT, DELETESCRIPT} from '../../../../utils/GraphQLAPI'
import {useLazyQuery, useMutation} from '@apollo/client'
import {Spinner} from 'react-bootstrap'
import SearchComponent from '../SearchComponent'
import {UsersListPagination} from '../../../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import './overrideBootstrap.css'
import TPVFilter from './TPVFilter'
import CreateScript from './CreateTPVScript/CreateScript'
import DownloadCsv from '../../Download/DownloadCsv'
import {alert, getToken} from '../../../../utils/helper'
import fileDownload from 'js-file-download'
import SwalThinkingImage from '../../../../_metronic/images/swal_thinking_face.svg'
import {useNavigate, useParams} from 'react-router-dom'

const MySwal = withReactContent(Swal)

const TPVScriptList = ({settingsAdded}: any) => {
  const [showModal, setShowModal] = useState(false)
  const [modalConfig, setModalConfig] = useState({})
  const [removeScript, setRemoveScript] = useState()
  const [listOptions, setListOptions] = useState<any>({
    commodityId: null,
    isActive: null,
    languageId: null,
    page: 1,
    perPage: 10,
    salesChannelId: null,
    searchText: '',
    utilityId: null,
  })

  const [activate, setActivate] = useState<any>({isActive: '', scriptId: '', scriptName: ''})

  const [fetchedValue, setFetchedValue] = useState<any>([])
  const [pageNo, updatePageNo] = useState<any>(0)

  const [downloadData, setDownloadData] = useState<any>([])
  const [filterTempOptions, setFilterTempOptions] = useState<any>()
  const [csv, setCsv] = useState<boolean>(false)
  const csvRef = useRef<any>(null)
  //for Modal
  const [loadedData, setLoadedData] = useState(false)
  const audio = new Audio()
  const networkOnly = 'network-only'
  const AreYouSureMsg = 'Are you sure?'
  const noCancelMsg = 'No, cancel !'
  const scriptStatusUpdateSuccessMsg = 'Script status updated successfully'
  const cancelBtnClr = 'rgb(39 37 37 / 52%)'
  const navigate = useNavigate()
  const getUrlParams = useParams()

  const [getScriptList, {loading, refetch}] = useLazyQuery(GET_ALL_SCRIPTS_LIST, {
    variables: {
      getScriptsInput: listOptions,
    },
    onCompleted: (data) => {
      setFetchedValue(data.getAllScripts)
    },
    onError: (err) => console.log('error', err),
    fetchPolicy: networkOnly,
  })
  const [deleteScript] = useMutation(DELETESCRIPT, {
    variables: {
      scriptId: removeScript,
    },
    onCompleted: () => {
      alert('Script deleted successfully', 'success')
      refetch()
    },
    onError: (err) => {
      alert(err.message, 'warning')
    },
  })

  // CSV Download API Hit
  const [getScriptCSVList, {loading: reload}] = useLazyQuery(GET_ALL_SCRIPTS_LIST, {
    fetchPolicy: networkOnly,
    variables: {
      getScriptsInput: filterTempOptions,
    },
    onCompleted: async (data) => {
      setDownloadData(
        data.getAllScripts.scripts.map((script: any) => {
          return {...script, status: script.status ? 'Active' : 'Inactive'}
        })
      )
    },
    onError: (err) => console.log('error', err),
  })

  const removeScripts = async (id: any, productName: any) => {
    setRemoveScript(await id)
    if (productName != null) {
      MySwal.fire({
        title: AreYouSureMsg,
        text: `The script is associated with Product(s) : ${productName}`,
        iconHtml: `<img src=${SwalThinkingImage}>`,
        customClass: {
          icon: 'no-border',
        },
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it',
        confirmButtonColor: '#3E97FF',
        cancelButtonText: noCancelMsg,
        reverseButtons: true,
      }).then(function (result) {
        if (result.value) {
          deleteScript()
        }
      })
    } else {
      MySwal.fire({
        title: AreYouSureMsg,
        text: "You won't be able to revert this",
        iconHtml: `<img src=${SwalThinkingImage}>`,
        customClass: {
          icon: 'no-border',
        },
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it',
        confirmButtonColor: '#3E97FF',
        cancelButtonText: noCancelMsg,
        cancelButtonColor: cancelBtnClr,
        reverseButtons: true,
      }).then(function (result) {
        if (result.value) {
          deleteScript()
        }
      })
    }
  }

  const RenderDropDown = (name: string) => {
    const temp = name.split(',')
    if (temp.length !== 0 && temp.length === 1) {
      return temp[0]
    } else if (temp.length !== 0) {
      return (
        <Dropdown className='show-override'>
          <Dropdown.Toggle
            id='dropdown-custom-1'
            className='text-gray-600 btn-override'
            style={{background: 'none!important'}}
          >
            {temp[0]}
            <span className='text-primary'>(+{temp.length - 1})</span>
          </Dropdown.Toggle>
          <Dropdown.Menu className='mh-175px py-2' style={{overflow: 'scroll', zIndex: '5'}}>
            {temp.map((item: any, index) => {
              if (index !== 0) {
                return <Dropdown.Item className='text-gray-600 fs-7 mb-1 p-0'>{item}</Dropdown.Item>
              }
              return ''
            })}
          </Dropdown.Menu>
        </Dropdown>
      )
    }
  }
  useEffect(() => {
    getScriptList()
  }, [listOptions])

  useEffect(() => {
    setListOptions((prevOptions: any) => {
      return {...prevOptions, page: pageNo + 1}
    })
  }, [pageNo])

  const updateRowsPerPage = (value: any) => {
    setListOptions((prevOptions: any) => {
      return {...prevOptions, perPage: value, page: pageNo + 1}
    })
  }
  const updateScriptPopup = (result: any) => {
    if (result.value) {
      updateScript()
      MySwal.fire({
        title: 'Success!',
        text: scriptStatusUpdateSuccessMsg,
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      })
    }
  }
  const handleSearch = (value: any) => {
    updatePageNo(0)
    setListOptions((prevOptions: any) => {
      return {...prevOptions, searchText: value, page: pageNo + 1}
    })
  }

  const [updateScript] = useMutation(UPDATE_SCRIPT, {
    variables: {
      updateScriptInput: {
        isActive: activate.isActive,
        scriptId: activate.scriptId,
        name: activate.scriptName,
      },
    },
    onCompleted: (data) => {
      refetch()
    },
  })

  const scriptActivate = (
    e: any,
    activeValue: any,
    scriptId: any,
    scriptName: any,
    productName: any
  ) => {
    e.preventDefault()

    setActivate((prevOptions: any) => {
      return {...prevOptions, isActive: activeValue, scriptId, scriptName}
    })

    if (productName != null) {
      if (activeValue) {
        MySwal.fire({
          title: AreYouSureMsg,
          iconHtml: `<img src=${SwalThinkingImage}>`,
          customClass: {
            icon: 'no-border',
          },
          showCancelButton: true,
          confirmButtonText: 'Yes, Activate it',
          confirmButtonColor: '#3E97FF',
          cancelButtonText: noCancelMsg,
          cancelButtonColor: cancelBtnClr,
          reverseButtons: true,
        }).then(function (result) {
          updateScriptPopup(result)
        })
      } else {
        MySwal.fire({
          title: AreYouSureMsg,
          text: `The script is associated with a Products:${productName}`,
          iconHtml: `<img src=${SwalThinkingImage}>`,
          customClass: {
            icon: 'no-border',
          },
          showCancelButton: true,
          confirmButtonText: 'Yes, Inactivate it',
          confirmButtonColor: '#3E97FF',
          cancelButtonText: noCancelMsg,
          cancelButtonColor: cancelBtnClr,
          reverseButtons: true,
        }).then(function (result) {
          updateScriptPopup(result)
        })
      }
    } else {
      MySwal.fire({
        title: AreYouSureMsg,
        iconHtml: `<img src=${SwalThinkingImage}>`,
        customClass: {
          icon: 'no-border',
        },
        showCancelButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor: '#3E97FF',
        cancelButtonText: noCancelMsg,
        cancelButtonColor: cancelBtnClr,
        reverseButtons: true,
      }).then(function (result) {
        updateScriptPopup(result)
      })
    }
  }

  const handleOpenModal = (mode: any, scriptId = '') => {
    if (settingsAdded) {
      setLoadedData(false)
      setModalConfig({
        mode,
        scriptId,
      })
      setShowModal(true)
    } else {
      MySwal.fire({
        icon: 'warning',
        title: 'Please complete script settings before adding a script',
      })
    }
  }

  const handleOpenAuditModal = (scriptId: any) => {
    navigate(`/${getUrlParams.adminUser}/script-audit`, {
      state: {
        itemId: scriptId,
        itemType: 'Script',
      },
    })
  }

  // TPV List CSV Download
  const csvHeaders = [
    {label: 'Script Name', key: 'scriptName'},
    {label: '#Prompts', key: 'prompts'},
    {label: 'Language', key: 'languageName'},
    {label: 'E_Utility', key: 'utility'},
    {label: 'G_Utility', key: 'gutility'},
    {label: 'Commodity', key: 'commodity'},
    {label: 'Product Name', key: 'productName'},
    {label: 'Sales Channel', key: 'salesChannel'},
    {label: 'Dial In Number', key: 'dailInNumber'},
    {label: 'Status', key: 'status'},
  ]

  useEffect(() => {
    const {page, perPage, ...rest} = listOptions
    setFilterTempOptions(rest)
    setCsv(false)
  }, [])

  useEffect(() => {
    if (listOptions && csv) {
      const {page, perPage, ...rest} = listOptions
      setFilterTempOptions(rest)
      setCsv(false)
    }
  }, [listOptions, csv])

  const csvDownloadFun = async () => {
    await getScriptCSVList()
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }
  const handleDownloadScript = async (scriptId: any, scriptName: any) => {
    const downloadURL = `${process.env.REACT_APP_BASE_URL}excel/downloadscripts/${scriptId}`
    const TOKEN = await getToken()
    const res = await fetch(downloadURL, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${TOKEN}`,
        // responseType: 'arraybuffer'
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
    })
    const blob = await res.blob()
    const newBlob = new Blob([blob])
    fileDownload(newBlob, `${scriptName}.xlsx`)
  }
  const renderUtility = (utility: string, gutility: string) => {
    const tempUtilities = []
    let finalutility: any = []
    utility && tempUtilities.push(utility)
    gutility && tempUtilities.push(gutility)
    tempUtilities.forEach(
      (utility: string) => (finalutility = [...finalutility, ...utility.split(',')])
    )
    finalutility = finalutility.filter(
      (utility: string, index: string) => finalutility.indexOf(utility) === index
    )
    return finalutility.join(',')
  }
  return (
    <KTCard>
      <div className='card card-custom'>
        <div className=' card-header card-body pb-0 border-0'>
          <div className='card-title'>
            <div className='d-flex align-items-center position-relative my-1'>
              <SearchComponent handleSearch={handleSearch} placeholder='Search script' />
            </div>
          </div>

          <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>
            {/* {fetchedValue.totalCountl !== 0 && */}
            <DownloadCsv
              csvDownloadFun={csvDownloadFun}
              reload={reload}
              csvHeaders={csvHeaders}
              csvRef={csvRef}
              downloadData={downloadData}
              downloadFileName='TPVList.csv'
            />
            {/* } */}
            <TPVFilter filterOptions={listOptions} setFilterOptions={setListOptions} />
            <button
              className='btn btn-primary fs-6'
              data-bs-toggle='modal'
              data-bs-target='#create-script'
              onClick={() => handleOpenModal('create')}
            >
              <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
              <span>Create Script</span>
            </button>
            <CreateScript
              show={showModal}
              modalConfig={modalConfig}
              setShowModal={setShowModal}
              getScriptList={getScriptList}
              loadedData={loadedData}
              setLoadedData={setLoadedData}
              audio={audio}
            />
            {/* <button className='btn btn-primary fs-6'>
              <img
                src='/static/media/smlplus.c647d4ea0e36f0fbce4982a3a2e67233.svg'
                alt=''
                className='svg-icon svg-icon-1'
              />
              <span>Create Script</span>
            </button> */}
          </div>
        </div>
        <KTCardBody className='pe-0 min-h-lg-450px min-h-md-300px' scroll={loading ? false : true}>
          {loading ? (
            <div className='text-center'>
              <Spinner animation='border' className='text-gray-600' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </Spinner>
            </div>
          ) : fetchedValue.totalCount !== 0 ? (
            <div className='table-responsive-xxl'>
              <table className='table table-row-dashed gy-7 gs-7'>
                <thead>
                  <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200 table_row'>
                    <th className='header_title header_title_spacing'>Script Name</th>
                    <th className='header_title header_title_spacing'>#Prompts</th>
                    <th className='header_title header_title_spacing'>Language</th>
                    <th className='header_title header_title_spacing'>Utility</th>
                    <th className='header_title header_title_spacing'>Commodity</th>
                    <th className='header_title header_title_spacing'>Product Name</th>
                    <th className='header_title header_title_spacing'>Sales Channel</th>
                    <th className='header_title header_title_spacing'>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {fetchedValue &&
                    fetchedValue?.scripts?.map((item: any, index: number) => {
                      return (
                        <tr className='border-bottom-2 name_spacing'>
                          <td
                            className='name'
                            style={{cursor: 'pointer'}}
                            onClick={() => handleOpenModal('preview', item.scriptId)}
                          >
                            {item.scriptName != null ? item.scriptName : '-'}
                          </td>
                          <td className='content'>{item.prompts != null ? item.prompts : '-'}</td>
                          <td className='content'>
                            {item.languageName != null ? RenderDropDown(item.languageName) : '-'}
                          </td>
                          {/* <td className='text-gray-600 fs-6 ps-0 fw-semibold'>{item.languageName!=null ? RenderDropDown(item.languageName):"-"}</td> */}
                          <td className='content'>
                            {item.utility !== null || item.gutility !== null
                              ? renderUtility(item.utility, item.gutility)
                              : '-'}
                          </td>

                          <td className='content'>
                            {item.commodity != null ? item.commodity : '-'}
                          </td>

                          <td className='content'>
                            {item.productName != null ? RenderDropDown(item.productName) : '-'}
                          </td>
                          <td className='content'>
                            {item.salesChannel != null ? RenderDropDown(item.salesChannel) : '-'}
                          </td>

                          <td className='content'>
                            <span
                              className={`badge badge-light-${item.status ? 'success' : 'danger'}`}
                            >
                              {item.status ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td className='text-gray-600 fs-6 ps-0 fw-semibold'>
                            <Dropdown className='show-override'>
                              <Dropdown.Toggle
                                id='dropdown-custom-1'
                                className='text-gray-600 btn btn-sm btn-icon btn-active-light-primary btn-light-primary btn-arrow-overide'
                                style={{background: 'none!important'}}
                              >
                                <i className='bi bi-three-dots-vertical fs-7 text-primary'></i>
                              </Dropdown.Toggle>
                              <form>
                                <Dropdown.Menu className=' py-2 menu-state-bg-primary'>
                                  <Dropdown.Item
                                    as='div'
                                    className='text-gray-600 fs-7 menu-item p-0'
                                  >
                                    <div
                                      className='menu-link'
                                      onClick={() => handleOpenModal('preview', item.scriptId)}
                                    >
                                      Preview
                                    </div>
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    as='div'
                                    className='text-gray-600 fs-7 menu-item p-0'
                                  >
                                    <div
                                      className='menu-link'
                                      onClick={() => handleOpenModal('edit', item.scriptId)}
                                    >
                                      Edit
                                    </div>
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    as='div'
                                    className='text-gray-600 fs-7 menu-item p-0'
                                  >
                                    <div
                                      className='menu-link'
                                      onClick={() => handleOpenModal('clone', item.scriptId)}
                                    >
                                      Clone
                                    </div>
                                  </Dropdown.Item>

                                  <Dropdown.Item
                                    as='div'
                                    className='text-gray-600 fs-7 menu-item p-0'
                                  >
                                    <div
                                      className='menu-link'
                                      onClick={(e) =>
                                        handleDownloadScript(item?.scriptId, item?.scriptName)
                                      }
                                    >
                                      Download
                                    </div>
                                  </Dropdown.Item>

                                  {item.status ? (
                                    <Dropdown.Item
                                      as='div'
                                      className='text-gray-600 fs-7 menu-item p-0'
                                    >
                                      <div
                                        // type='submit'
                                        className='menu-link'
                                        // style={{border: 'none', background: 'none'}}
                                        onClick={(e) =>
                                          scriptActivate(
                                            e,
                                            false,
                                            item.scriptId,
                                            item.scriptName,
                                            item.productName
                                          )
                                        }
                                      >
                                        Inactivate
                                      </div>
                                    </Dropdown.Item>
                                  ) : (
                                    <Dropdown.Item
                                      as='div'
                                      className='text-gray-600 fs-7 menu-item p-0'
                                    >
                                      <div
                                        // type='submit'
                                        className='menu-link'
                                        // style={{border: 'none', background: 'none'}}
                                        onClick={(e) =>
                                          scriptActivate(
                                            e,
                                            true,
                                            item.scriptId,
                                            item.scriptName,
                                            item.productName
                                          )
                                        }
                                      >
                                        Activate
                                      </div>
                                    </Dropdown.Item>
                                  )}
                                  <Dropdown.Item
                                    as='div'
                                    className='text-gray-600 fs-7 menu-item p-0'
                                  >
                                    <div
                                      className='menu-link'
                                      onClick={(e) => handleOpenAuditModal(item?.scriptId)}
                                    >
                                      Audit
                                    </div>
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    as='div'
                                    className='text-gray-600 fs-7 menu-item p-0'
                                  >
                                    <div
                                      className='menu-link text-danger text-hover-white'
                                      onClick={() => removeScripts(item.scriptId, item.productName)}
                                    >
                                      Delete
                                    </div>
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </form>
                            </Dropdown>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className='fs-4 fw-semibold text-center text-muted min-h-400px d-flex-align-items-center justify-content-center'>
              <div>No Results Found</div>
            </div>
          )}
        </KTCardBody>
        {fetchedValue?.totalCount > 0 ? (
          <div className='card-footer border-0'>
            <UsersListPagination
              page={pageNo}
              total={fetchedValue.totalCount}
              updatePage={updatePageNo}
              recordsPerPage={(e: any) => {
                updateRowsPerPage(parseInt(e))
              }}
              rowsPerPage={listOptions.perPage}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </KTCard>
  )
}

export default TPVScriptList
